import { SpeakerProfile } from '../../../lib/api';

export const formatSpeakerNames = (speakers: SpeakerProfile[]): string[] => {
  const names = speakers.map((s) => s.name).filter(Boolean);
  const total = names.length;

  if (total <= 1) {
    return names;
  }

  return names.map((name, index) => {
    const isLast = index === total - 1;
    return isLast ? `& ${name}` : `${name},`;
  });
};


